import { useIntl } from '@capsicum/common';
import { Avatar, Button } from '@capsicum/common-web';
import { type PartnerWithImageMap, type SelectFavouriteTeamSelectionVariants } from '@capsicum/socios-core';
import styled, { css } from 'styled-components';

import { BottomButtonsContent, BottomButtonsWrapper } from './SelectFavouriteTeam.styled';

type FooterPageContainerProps = {
	isSubmittable: boolean;
	maxWidth: number;
	onSubmit: () => void;
	selectedPartner?: null | PartnerWithImageMap;
	selection: SelectFavouriteTeamSelectionVariants;
};

export const FooterPageContainer = ({
	isSubmittable,
	maxWidth,
	onSubmit,
	selectedPartner,
	selection
}: FooterPageContainerProps) => {
	const { $t } = useIntl();

	return (
		<BottomButtonsWrapper $isPage>
			<S.BottomButtonsContentStyled $maxWidth={maxWidth} $selection={selection}>
				{selection === 'favourite' && (
					<div>
						{selectedPartner && (
							<Avatar
								size="S"
								src={selectedPartner.images?.partnerLogo?.url}
								testID={`selectFavouriteTeam-avatar-${selectedPartner.name}`}
							/>
						)}
					</div>
				)}

				<Button
					disabled={!isSubmittable}
					testID="selectFavouriteTeam-submit-button"
					text={$t(`selectFavouriteTeam.actions.${selection}`)}
					onClick={onSubmit}
				/>
			</S.BottomButtonsContentStyled>
		</BottomButtonsWrapper>
	);
};

namespace S {
	export const BottomButtonsContentStyled = styled(BottomButtonsContent)<{
		$selection: FooterPageContainerProps['selection'];
	}>`
		${({ $selection }) =>
			$selection === 'follow' &&
			css`
				justify-content: flex-end;
			`}
	`;
}
